import React, { useState } from 'react';
import { Form } from 'react-bootstrap';

import { useAuth } from '../../../common/hooks/useAuth';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { UserCertificateUpload } from '../../components/Users/UserCertificateUpload';

export const UserCertificateView: React.FC = () => {
  const auth = useAuth();
  const spd = useSpdCore();
  const profile = auth.userProfile;
  const [isSavingPreference, setIsSavingPreference] = useState(false);

  if (!profile?.id) {
    return null;
  }

  const handleSignP1WithSzafirChange = async (checked: boolean) => {
    setIsSavingPreference(true);
    try {
      await spd.users.setSignP1WithSzafir(profile.id, checked);
      await auth.updateProfile({ ...profile, signP1WithSzafir: checked });
    } finally {
      setIsSavingPreference(false);
    }
  };

  return (
    <main className="form-signin">
      <h3 className="fw-normal mb-3">Certyfikat SIM</h3>
      <h5 className="fw-normal mb-3">
        Dane do podpisywania dokumentów medycznych:
      </h5>
      <UserCertificateUpload
        userId={profile.id}
        hasCertificate={profile.hasCertificate}
        currentPwz={profile.pwz ?? undefined}
        currentOccupationalMedicineDoctorIdentifier={
          profile.occupationalMedicineDoctorIdentifier ?? undefined
        }
      />
      <Form.Check
        type="checkbox"
        id="sign_p1_with_szafir"
        className="mt-3"
        label="Podpisuj dokumenty wysyłane do SIM (P1) Szafirem, zamiast certyfikatem zapisanym w systemie"
        checked={profile.signP1WithSzafir ?? false}
        disabled={isSavingPreference}
        onChange={e => handleSignP1WithSzafirChange(e.target.checked)}
      />
    </main>
  );
};
